import { combineReducers } from 'redux';
import { foldersReducer } from './folders';
import { latestUpdatedReducer } from './latestUpdated';
import { decisionsReducer } from './decisions';

export const reducersRaw = {
  folders: foldersReducer,
  latestUpdated: latestUpdatedReducer,
  decisions: decisionsReducer,
};

export const reducers = combineReducers(reducersRaw);
